import React from 'react';
import { Select } from '@cx/ui';
import { DataDrivenFilterType } from 'types';
import { DimensionOptionType } from '../types';
import DataDrivenFilterOption from './DataDrivenFiltersOption';

type DataDrivenFilterDimensionProps = {
  selectedFilter: DataDrivenFilterType;
  dimensions: DimensionOptionType[];
  selectedFilterIndex: number;
  selectedPartitionIndex: number;
  isLoading: boolean;
  onDimensionSelected: (
    option: DimensionOptionType,
    selectedFilterIndex: number
  ) => void;
} & Pick<React.HTMLAttributes<HTMLDivElement>, 'className'>;

/**
 * Renders the dimension selector for the enterprise filter.
 * the user can select and change the dimension of the filter.
 * When the user selects a dimension, the option selector will be rendered.
 * @param param0
 * @returns
 */

function DataDrivenFilterDimension({
  className,
  selectedFilter,
  dimensions,
  selectedFilterIndex,
  selectedPartitionIndex,
  isLoading,
  onDimensionSelected,
}: DataDrivenFilterDimensionProps) {
  const handleDimensionSelected = (option: DimensionOptionType) => {
    onDimensionSelected(option, selectedFilterIndex);
  };
  const selectedDimension = selectedFilter?.data?.dimension;
  const value = selectedDimension
    ? {
        label: selectedDimension.ShortText,
        value: selectedDimension.ColumnName,
        dimension: selectedDimension,
      }
    : undefined;

  return (
    <div className={className}>
      <Select
        name="enterprise-filter-dimenstion-selector"
        placeholder="Select a dimension"
        className="select"
        options={dimensions}
        value={value}
        onChange={handleDimensionSelected}
        maxMenuHeight={250}
        isLoading={isLoading}
      />
      {selectedDimension ? (
        <DataDrivenFilterOption
          selectedFilterIndex={selectedFilterIndex}
          selectedPartitionIndex={selectedPartitionIndex}
        />
      ) : null}
    </div>
  );
}

export default DataDrivenFilterDimension;
